module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body municipalizacao"
  }, [(_vm.travarMunicipios && _vm.existeMunicipioRepetido.length > 0) ? _c('div', {
    staticClass: "column start-centered municipio-duplicidade-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', _vm._l((_vm.existeMunicipioRepetido), function(municipio) {
    return _c('div', [_vm._v("\n        - " + _vm._s(municipio.ds_municipio) + " / " + _vm._s(municipio.ds_uf) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraGrid),
      expression: "mostraGrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.formEditavel) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onNew
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Município")]), _vm._v(" "), (_vm.table.items.length > 0 && _vm._.includes(_vm.layout, 'COM_BOTOES_DISTRIBUICAO')) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "title": '<h5>Redistribuirá proporcionalmente, o total de <span class=\'realce\'>' + _vm.totais.participantes.projeto + '</span> participantes desse projeto nos <span class=\'realce\'>' + _vm.table.items.length + '</span> municípios abaixo (exceto contrapartidas)</h5>'
    },
    on: {
      "click": _vm.distribuirParticipantes
    }
  }, [_c('i', {
    staticClass: "fa fa-server",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Participantes\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.table.items.length > 0 && _vm._.includes(_vm.layout, 'COM_BOTOES_DISTRIBUICAO')) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "title": '<h5>Redistribuirá proporcionalmente, o valor total de cada origem do recurso (fase) nos <span class=\'realce\'>' + _vm.table.items.length + '</span> municípios abaixo</h5>'
    },
    on: {
      "click": _vm.distribuirValores
    }
  }, [_c('i', {
    staticClass: "fa fa-server",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Valores")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "600px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-bottom": "1rem"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.municipalizacao, function(m) {
        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), m.id)
      })) : _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.modificacaoLinha,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([(!_vm.visaoReduzida) ? {
      key: "ds_fase",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
          staticClass: "pull-left"
        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Excluído")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.etiquetaOrigemRecurso(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_fase.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm.etiquetaOrigemRecurso('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_fase.0', ''))) + "\n                  ")]) : _vm._e()])]
      }
    } : null, {
      key: "ds_cep",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("cep")(('' + row.value))))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_cep.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("cep")(('' + _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_cep.0', '')))) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "ds_municipio",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(row.value) + " "), (_vm._.has(row.item, 'ds_uf')) ? _c('span', [_vm._v(" / " + _vm._s(row.item.ds_uf))]) : _vm._e()]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_municipio.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_municipio.0', '')) + "\n                  ")]) : _vm._e()])]
      }
    }, (!_vm.visaoReduzida) ? {
      key: "dc_valor_municipio",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("real")(row.value)))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'dc_valor_municipio.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("real")(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'dc_valor_municipio.0', ''))) + "\n                  ")]) : _vm._e()])]
      }
    } : null, {
      key: "nr_total_participantes",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-table"
          }
        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_total_participantes.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_total_participantes.0', '')) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!_vm._.has(_vm.$route.params, 'numero') || _vm.formEditavel) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
          staticClass: "btn btn-back btn-flat btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.reincluir(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Desfazer")])], 1) : _c('span', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.confirmaExclusao(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir\n                    ")])], 1)]) : _vm._e()]
      }
    }], null, true)
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Fundação")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Contrapartida")]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total do Projeto")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Participantes")])]), _vm._v(" "), _c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor",
    attrs: {
      "title": '<h5>Valor total da Fundação que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
        return m.ds_fase === '1'
      }))['true'] + '</span> município(s) acima</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.fbb)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor",
    attrs: {
      "title": '<h5>Valor total de Parceiro Estrtégico que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
        return m.ds_fase === '5'
      }))['true'] + '</span> município(s) acima</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.parceiros)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor",
    attrs: {
      "title": '<h5>Valor total de Contrapartida que já distribuiu em <span class=\'realce\'>' + (_vm._.countBy(_vm.table.items, function(m) {
        return m.ds_fase === '2'
      }))['true'] + '</span> município(s) acima</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.totais.valor.municipalizados.contrapartidas)))])]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
    staticClass: "centralizado"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor",
    attrs: {
      "title": '<h5>Valor total do projeto que já distribuiu em <span class=\'realce\'>' + _vm.table.items.length + '</span> registros(s) acima</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")((_vm.totais.valor.municipalizados.fbb + _vm.totais.valor.municipalizados.parceiros + _vm.totais.valor.municipalizados.contrapartidas))))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor",
    attrs: {
      "title": '<h5>Total de participantes distribuídos em <span class=\'realce\'>' + _vm.table.items.length + '</span> registros(s) acima</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.totais.participantes.municipalizados))])])]), _vm._v(" "), _c('tr', [(!_vm.visaoReduzida && _vm.totais.valor.projeto.fbb != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [(Math.abs(_vm.totais.valor.restantes.fbb) > 0.1) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor atencao",
    attrs: {
      "title": '<h5>' + (_vm.totais.valor.restantes.fbb < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.fbb : 'Valor ainda Restante da Fundação que deve informar para qual município será destinado') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.fbb)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.parceiros != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [(Math.abs(_vm.totais.valor.restantes.parceiros) > 0.1) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor atencao",
    attrs: {
      "title": '<h5>' + (_vm.totais.valor.restantes.parceiros < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.parceiros : 'Valor ainda Restante de Parceiro Estratégico que deve informar para qual município será destinado') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.parceiros)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida && _vm.totais.valor.projeto.contrapartidas != 0) ? _c('td', {
    staticClass: "centralizado"
  }, [(Math.abs(_vm.totais.valor.restantes.contrapartidas) > 0.1) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor atencao",
    attrs: {
      "title": '<h5>' + (_vm.totais.valor.restantes.contrapartidas < 0 ? 'Ultrapassou o valor máximo de R$ ' + _vm.totais.valor.projeto.contrapartidas : 'Valor ainda Restante da Contrapartida que deve informar para qual município será destinado') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor.restantes.contrapartidas)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.visaoReduzida) ? _c('td', {
    staticClass: "centralizado"
  }, [(Math.abs(_vm.totais.valor.restantes.fbb + _vm.totais.valor.restantes.parceiros + _vm.totais.valor.restantes.contrapartidas) > 0.1) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor atencao",
    attrs: {
      "title": '<h5>Valor ainda Restante do projeto aguardando em qual município será destinado</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")((_vm.totais.valor.restantes.fbb + _vm.totais.valor.restantes.parceiros + _vm.totais.valor.restantes.contrapartidas))))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.participantes.restantes !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "valor atencao",
    attrs: {
      "title": '<h5>' + (_vm.totais.participantes.restantes < 0 ? 'Informou mais participantes do que há em publico-alvo<br/>Corrija e salve a proposta para continuar' : 'Total de participantes ainda Restante do projeto que deve informar a qual município faz parte') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm.totais.participantes.restantes))]) : _vm._e()])])])])])], 1)])]), _vm._v(" "), (!_vm.mostraGrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.visaoReduzida) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('origem')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade.ds_fase),
      expression: "cidade.ds_fase"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "origem",
      "aria-label": "Recurso"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cidade, "ds_fase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selecionaFase]
    }
  }, [(_vm.temItemOrigem(1)) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.temItemOrigem(2)) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Contrapartida")]) : _vm._e(), _vm._v(" "), (_vm.temItemOrigem(5)) ? _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Parceiro Estratégico")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:8'),
      expression: "'required|min:8|max:8'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "type": "text",
      "disabled": _vm.loading.cepMunicipio,
      "mask": "#####-###"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.buscaCidades([_vm.cidade])
      }
    },
    model: {
      value: (_vm.cidade.ds_cep),
      callback: function($$v) {
        _vm.$set(_vm.cidade, "ds_cep", $$v)
      },
      expression: "cidade.ds_cep"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding": "7px"
    }
  }, [(_vm.loading.cepMunicipio) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Consultando CEP ...")]) : (_vm.cidade.ds_municipio) ? _c('span', [_vm._v(_vm._s(_vm.cidade.ds_municipio) + " - " + _vm._s(_vm.cidade.ds_uf))]) : _vm._e()])]), _vm._v(" "), (!_vm.visaoReduzida) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('valor')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valor neste município:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:' + _vm.valorMaximo(_vm.cidade).toFixed(2)),
      expression: "'required|min_value:0|max_value:' + valorMaximo(cidade).toFixed(2)"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "valor",
      "type": "text",
      "disabled": !_vm.cidade.ds_fase
    },
    model: {
      value: (_vm.cidade.dc_valor_municipio),
      callback: function($$v) {
        _vm.$set(_vm.cidade, "dc_valor_municipio", $$v)
      },
      expression: "cidade.dc_valor_municipio"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('número de participantes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Número de participantes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "approval": "addMunCtrl.approval",
      "state": "addMunCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade.nr_total_participantes),
      expression: "cidade.nr_total_participantes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        numeric: true
      }),
      expression: "{required: true, numeric: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "número de participantes",
      "type": "number",
      "min": "0",
      "disabled": ('' + _vm.cidade.ds_fase === '2')
    },
    domProps: {
      "value": (_vm.cidade.nr_total_participantes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cidade, "nr_total_participantes", $event.target.value)
      }
    }
  }), _vm._v(" "), (('' + _vm.cidade.ds_fase === '2')) ? _c('span', {
    staticClass: "alerta"
  }, [_c('br'), _vm._v("Contrapartida não deve ter participantes")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('número de participantes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [(!_vm.loading.cepMunicipio && (_vm._.isNil(_vm.processoSolicitacao) || _vm.cidade.dc_valor_municipio > 0)) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atenção, existe(m) município(s) cadastrado(s) em duplicidade, favor regularizar antes de criar o número do projeto")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01776124!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/municipalizacao.vue
// module id = 1847
// module chunks = 1